import type { PayloadAction } from "@reduxjs/toolkit";

import type { IToggleFilters } from "./models";

export const TOGGLE_FAVORITES = "subscriptions/toggleFavorites";
export function toggleFavorites(
  payload: boolean,
): PayloadAction<boolean> {
  return {
    type: TOGGLE_FAVORITES,
    payload,
  };
}

export const TOGGLE_SUBSCRIPTIONS = "subscriptions/toggleSubscriptions";
export function toggleSubscriptions(
  payload: boolean,
): PayloadAction<boolean> {
  return {
    type: TOGGLE_SUBSCRIPTIONS,
    payload,
  };
}

export const UPDATE = "subscriptions/update";
export function updateSubscriptions(
  payload: IToggleFilters,
): PayloadAction<IToggleFilters> {
  return {
    type: UPDATE,
    payload,
  };
}
